export const CANCEL = 'Apply promo code dialog. Cancel'
export const NEXT = 'Apply promo code dialog. Next'
